<template>
  <base-dialog-form ref="iscrizioneEventoDialog" :title="$t('event_booking')" :text="eventData ? eventData.titolo : ''"
    color="secondary" :type="type" icon="mdi-calendar-check">
    <v-container v-if="eventData">
      <v-row v-if="RBAC_INSERT_OTHER_USER">
        <v-col cols="12">
          <v-autocomplete v-model="masterId" :items="selectUsers" item-text="text" item-value="value" @change="resetForm"
            dense :label="$t('select_user')"></v-autocomplete>
        </v-col>
      </v-row>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{
            $t("info_event")
          }}</v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{
            $t("select_options")
          }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :step="3" :editable="stepper >= 3" :complete="stepper > 3">{{
            $t("confirm_profile_data")
          }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4" :editable="stepper >= 4" :complete="stepper > 4">{{
            $t("exec_payment")
          }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-container>
              <v-row>
                <v-col cols="12" class="text-center">
                  <h2>{{ eventData.titolo }}</h2>
                </v-col>
              </v-row>
              <v-row class="rigaInfo">
                <v-col md="6" cols="12" class="colInfo text-center">
                  <img class="locandina" :src="eventData.image" />
                </v-col>
                <v-col md="6" cols="12" class="colInfo text-center">
                  <div class="text-evento" v-html="eventData.descr" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-center">
                  <v-btn v-if="!eventData.requireTesseramento" :disabled="!eventData.attivo || !eventData.canSubscribe"
                    color="success" @click="readedInfo">{{ $t("next") }}</v-btn>
                  <v-btn v-if="eventData.requireTesseramento" color="success" @click="tesseramento">{{
                    $t("required_affiliation")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <v-container>
              <v-card v-for="pacchetto in eventData.pacchetti" v-bind:key="pacchetto.idPacchetto">
                <v-card-title>{{ pacchetto.descr }}</v-card-title>
                <v-container>
                  <v-row class="text-center" v-for="dettaglio in pacchetto.dettagli" v-bind:key="dettaglio.idDettaglio">
                    <v-col md="4" cols="12">
                      <v-radio-group @change="
                        selectOpzione(pacchetto.dettagliScelti, dettaglio)
                        " :error="pacchetto.errorRequired" :disabled="!pacchetto.enabled || dettaglio.postiLiberi <= 0"
                        :error-messages="pacchetto.errorRequired ? $t('required') : null
                          " v-if="pacchetto.multiscelta === 0" v-model="pacchetto.dettagliScelti[0]">
                        <v-radio :disabled="!dettaglio.enabled" :label="dettaglio.testo"
                          :value="dettaglio.idDettaglio"></v-radio>
                      </v-radio-group>

                      <v-checkbox v-else @change="
                        selectOpzione(pacchetto.dettagliScelti, dettaglio)
                        " :error="pacchetto.errorRequired" :disabled="!dettaglio.enabled || dettaglio.postiLiberi <= 0"
                        :error-messages="pacchetto.errorRequired ? $t('required') : null
                          " :multiple="pacchetto.multiscelta === 0 ? false : true" v-model="pacchetto.dettagliScelti"
                        :label="dettaglio.testo" :value="dettaglio.idDettaglio"></v-checkbox>
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-select v-if="dettaglio.opzioni && dettaglio.opzioni.length > 0"
                        :error="dettaglio.errorRequiredOptions" :error-messages="dettaglio.errorRequiredOptions ? $t('required') : null
                          " v-model="dettaglio.selectedOptions" :items="dettaglio.opzioni" :disabled="!dettaglio.enabled ||
    pacchetto.dettagliScelti === undefined ||
    !pacchetto.dettagliScelti.includes(
      dettaglio.idDettaglio
    )
    " :menu-props="{ maxHeight: '400' }" :label="$t('options')" color="primary"></v-select>
                      <v-combobox v-if="dettaglio.garaMode && dettaglio.garaMode !== 'I'"
                        :error="dettaglio.errorRequiredTeams"
                        :error-messages="dettaglio.errorRequiredTeams ? $t('required') : null"
                        v-model="dettaglio.selectedGaraPartecipanti" :items="dettaglio.garaPartecipanti" :disabled="!dettaglio.enabled ||
                          pacchetto.dettagliScelti === undefined ||
                          !pacchetto.dettagliScelti.includes(
                            dettaglio.idDettaglio
                          )
                          " :menu-props="{ maxHeight: '400' }" :label="$t('team')" color="primary"></v-combobox>
                    </v-col>
                    <v-col v-if="dettaglio.postiTotali && (!eventData.minPercShowOccupation || eventData.minPercShowOccupation < (dettaglio.postiOccupati * 100) /
                      dettaglio.postiTotali)" md="2" cols="6">
                      {{ $t("free_places") }} {{ dettaglio.postiLiberi }} /
                      {{ dettaglio.postiTotali }}
                      <br />
                      <br />
                      <v-progress-linear color="primary" :value="(dettaglio.postiOccupati * 100) /
                        dettaglio.postiTotali
                        "></v-progress-linear>
                    </v-col>
                    <v-col md="2" cols="6">
                      <v-text-field v-model="dettaglio.prezzo" :label="$t('price')" :disabled="!dettaglio.enabled ||
                        !RBAC_CAN_CHANGE_PRICE ||
                        pacchetto.dettagliScelti === undefined ||
                        !pacchetto.dettagliScelti.includes(
                          dettaglio.idDettaglio
                        )
                        " type="number" hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
              <v-row>
                <v-col cols="12" class="text-center">
                  <v-btn color="success" @click="confirmOptions" type="submit">{{ $t("confirm") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
          <v-stepper-content :step="3">
            <user-edit-profile :paramsMasterId="masterId" paramsMode="EDIT" paramsType="plain" :paramsIfConfirm="true"
              @isUpdated="stepper = 4"></user-edit-profile>
          </v-stepper-content>
          <v-stepper-content :step="4">
            <select-mod-pag :riepilogo="riepilogo" :usePoint="true" @selected="confirmOrder"
              :idEvento="idEvento"></select-mod-pag>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";
import userEditProfile from "@/widget/userEditProfile.vue";
import selectModPag from "@/widget/selectModPag.vue";

export default {
  name: "iscrizione-evento",
  components: {
    userEditProfile,
    selectModPag,
  },
  props: {
    paramsIdEvento: {
      type: Number,
      default: null,
    },
    paramsMasterId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      idEvento: null,
      masterId: null,
      stepper: 1,
      type: "dialog",
      eventData: null,
      selectUsers: [],
      opzioniScelte: [],
      pagId: null,
      dataPag: null,
      riepilogo: {
        headers: [
          { text: this.$t("packet"), value: "dexPacchetto" },
          { text: this.$t("item"), value: "dexDettaglio" },
          { text: this.$t("option"), value: "selectedOptions" },
          { text: this.$t("price"), value: "prezzo" },
        ],
        items: [],
        totale: 0,
      },
      RBAC_INSERT_OTHER_USER: false,
      RBAC_CAN_CHANGE_PRICE: false,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    if (this.paramsIdEvento) {
      this.type = "card";
      if (this.paramsMasterId) this.masterId = this.paramsMasterId;
      this.idEvento = this.paramsIdEvento;
      this.loadData();
    }
  },
  created() {
    let _ = this;
    _.masterId = parseInt(window.myData.masterId);
    _.RBAC_INSERT_OTHER_USER = _.checkUserRole("eventi", "INSERT_OTHER_USER");
    _.RBAC_CAN_CHANGE_PRICE = _.checkUserRole("eventi", "CAN_CHANGE_PRICE");
  },
  watch: {
    paramsIdEvento: function (newVal, oldVal) {
      // watch it
      if (newVal) {
        this.type = "card";
        if (this.paramsMasterId) this.masterId = this.paramsMasterId;
        this.idEvento = newVal;
        this.loadData();
        this.$refs.iscrizioneEventoDialog.open();
      }
    },
  },
  methods: {
    tesseramento() {
      this.$router.push("/portal/tesserati/tesseramento");
    },
    open(idEvento) {
      this.type = "dialog";
      this.idEvento = idEvento;
      this.loadData();
      this.$refs.iscrizioneEventoDialog.open();
    },
    loadData() {
      let url = "/auth/eventi/getEvento/" + this.masterId + "/" + this.idEvento;
      let _ = this;
      _.eventData = false;
      _.selectUsers = [];
      _.chiamataAxios("GET", url).then((response) => {
        _.eventData = response.data;
        if (_.RBAC_INSERT_OTHER_USER) {
          let url = "/auth/portal/listUsers";
          let filter = {};
          if (_.eventData.onlySoci === 1) {
            filter = { filter: { type: "tesserati" } };
          }
          _.chiamataAxios("POST", url, { body: filter }).then((response) => {
            _.selectUsers = response.data.map(function (item) {
              return {
                value: item.masterId,
                text:
                  item.surname +
                  " " +
                  item.name +
                  "   -   " +
                  item.resCity +
                  " (" +
                  item.eta +
                  " anni)",
              };
            });
          });
        }

        _.eventData.pacchetti = _.eventData.pacchetti.map(function (pacchetto) {
          pacchetto.dettagli = pacchetto.dettagli.map(function (dettaglio) {
            dettaglio.errorRequiredOptions = false;
            return dettaglio;
          });
          pacchetto.errorRequired = false;
          return pacchetto;
        });
      });
    },
    selectOpzione(scelti, dettaglio) {
      if (!dettaglio.selectedOptions)
        dettaglio.selectedOptions = dettaglio.opzioni[0];
      return true;
    },
    readedInfo() {
      // Controllo certificato
      let blocco = false;
      let validato = false;
      let ok = true;
      if (this.eventData.certRequired >= 1) {
        if (this.eventData.certRequired === 1) {
          blocco = false;
          validato = false;
        }
        if (this.eventData.certRequired === 2) {
          blocco = true;
          validato = false;
        }
        if (this.eventData.certRequired === 3) {
          blocco = false;
          validato = true;
        }
        if (this.eventData.certRequired === 4) {
          blocco = true;
          validato = true;
        }
        if (
          !this.eventData.certificato.caricato ||
          (validato && !this.eventData.certificato.validato)
        )
          ok = false;
      }

      if (ok) this.stepper = 2;
      else {
        Swal.fire({
          title: this.$t("this_event_require_certificate"),
          text: this.$t("upload_certificate_or_contact_staff"),
          type: "warning",
          showCancelButton: true,
          showConfirmButton: !blocco,
          customClass: "v-application",
          confirmButtonClass:
            "mx-5 v-btn v-btn--contained theme--light v-size--default",
          cancelButtonClass:
            "mx-5 v-btn v-btn--contained theme--light v-size--default",
          confirmButtonText: this.$t("continue"),
          cancelButtonText: this.$t("back"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value && !blocco) this.stepper = 2;
          else return false;
        });
      }
    },
    resetForm() {
      this.stepper = 1;
      this.tessera = null;
      this.idProduct = null;
      this.idDisciplina = null;
      this.confirmedCondition = null;
      this.productConfig = null;
      this.loadData();
    },
    confirmOptions() {
      let error = false;
      let _ = this;
      _.opzioniScelte = [];
      _.riepilogo.items = [];
      let totale = 0;
      // Controllo form
      _.eventData.pacchetti = this.eventData.pacchetti.map((pacchetto) => {
        pacchetto.errorRequired = false;
        let scelti = [];
        if (pacchetto.enabled && pacchetto.dettagliScelti !== undefined) {
          scelti = pacchetto.dettagli.map((dettaglio) => {
            if (
              dettaglio.enabled &&
              pacchetto.dettagliScelti.includes(dettaglio.idDettaglio)
            )
              return dettaglio.idDettaglio;
          });
        }
        if (pacchetto.required === 1 && pacchetto.dettagliScelti.length === 0) {
          pacchetto.errorRequired = true;
          error = true;
        }
        pacchetto.dettagli = pacchetto.dettagli.map(function (dettaglio) {
          dettaglio.errorRequiredOptions = false;

          if (scelti.includes(dettaglio.idDettaglio)) {
            totale += parseInt(dettaglio.prezzo);

            let opzione = {
              idPacchetto: pacchetto.idPacchetto,
              idDettaglio: dettaglio.idDettaglio,
              selectedOptions: dettaglio.selectedOptions,
              text: dettaglio.testo,
              prezzo: dettaglio.prezzo,
              idGareDettaglio: dettaglio.idGareDettaglio
            }

            let opzioneRiepilogo = {
              dexPacchetto: pacchetto.descr,
              dexDettaglio: dettaglio.testo,
              selectedOptions: dettaglio.selectedOptions,
              prezzo: dettaglio.prezzo,
              idGareDettaglio: dettaglio.idGareDettaglio
            }

            if (dettaglio.idGareDettaglio) {
              opzione.metadata = {
                idGarePartecipanti: null,
                textGarePartecipanti: ""
              }
              if (dettaglio.garaMode === 'I') {
                opzione.metadata.textGarePartecipanti = _.$t('individual')
              } else {
                if (dettaglio.selectedGaraPartecipanti) {
                  if (dettaglio.selectedGaraPartecipanti.value) {
                    opzione.metadata.idGarePartecipanti = dettaglio.selectedGaraPartecipanti.value;
                    opzione.metadata.textGarePartecipanti = dettaglio.selectedGaraPartecipanti.text;
                  }
                  else {
                    opzione.metadata.textGarePartecipanti = dettaglio.selectedGaraPartecipanti;
                  }
                }
              }

              opzioneRiepilogo.selectedOptions = dettaglio.garaMode === 'I' ? opzione.metadata.textGarePartecipanti : _.$t('team') + ": " + opzione.metadata.textGarePartecipanti
            }
            _.opzioniScelte.push(opzione);
            _.riepilogo.items.push(opzioneRiepilogo);
            if (
              !dettaglio.selectedOptions &&
              dettaglio.opzioni &&
              dettaglio.opzioni.length > 0
            ) {
              error = true;
              dettaglio.errorRequiredOptions = true;
            }

            if (
              !dettaglio.selectedGaraPartecipanti &&
              dettaglio.garaMode &&
              dettaglio.garaMode !== "I"
            ) {
              error = true;
              dettaglio.errorRequiredTeams = true;
            }
          }

          return dettaglio;
        });

        return pacchetto;
      });
      if (_.opzioniScelte.length === 0) {
        error = true;
      }
      _.riepilogo.totale = totale;
      if (!error) this.stepper = 3;
    },
    confirmOrder(pagamento) {
      this.dataPag = pagamento.dataPag;
      this.pagId = pagamento.pagId;

      let data = {
        opzioniScelte: this.opzioniScelte,
        pagId: this.pagId,
        dataPag: this.dataPag,
        usePoint: pagamento.selectedPoint,
      };
      let _ = this;
      let url =
        "/auth/eventi/savePartecipazione/" +
        this.masterId +
        "/" +
        this.idEvento;
      this.chiamataAxios("POST", url, { body: data, dialogLoader: true }).then(
        (response) => {
          if (response.data.payUrl) {
            Swal.fire({
              title: _.$t("redirect_to_external_site"),
              html: _.$t("for_complete_the_payment_operation"),
            }).then((result) => {
              window.open(response.data.payUrl);
            });
          } else {
            Swal.fire({
              type: response.msg.esito ? "success" : "error",
              title: response.msg.esito
                ? _.$t("operation_successfully_completed")
                : _.$t("there_was_an_error"),
              html: response.msg.msgTxt,
            });
          }
          _.$router.push("/portal/");
        }
      );
    },
  },
};
</script>

<style scoped>
.rigaInfo {
  height: auto;
}

.colInfo {
  height: 100%;
}

.locandina {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: auto;
}

.text-evento {
  height: 450px;
  overflow-y: auto;
}
</style>